import { Box, FormControlLabel, Switch, Tooltip, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import type { ImageI, ItemI, SequenceI } from "tweenly"
import { getObjectDataSourceContent } from "tweenly"
import ExpandableSection from "../../../common/ExpandableSection"
import PropertyRow from "../../../common/PropertyTools/PropertyRow"
import DataSourceIndicator from "../../DataSource/DataSourceIndicator"
import LoadImageButton from "../../ObjectsTree/LoadImageButton"

interface Props {
    object: ItemI | ImageI | SequenceI
    handleSetStyleValue: (property: any, value: any) => void
    handleSetObjectValue: (property: any, value: any) => void
    handleSetAttributeValue: (property: any, value: any) => void
}

const ImageProperties = ({
    object,
    handleSetStyleValue,
    handleSetObjectValue,
    handleSetAttributeValue,
}: Props) => {
    const isImageEditable: boolean = object?.attributes.find(
        (attr) => attr.property === "isImageEditable"
    )?.value

    const isImageSequence: boolean = object?.type === "sequence"
    const { t } = useTranslation()

    const handleChangeEditable = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation()
        handleSetAttributeValue("isImageEditable", !isImageEditable)
    }
    return (
        <ExpandableSection
            expanded={true}
            title="Image"
            secondaryActionComponent={
                object.type === "image" ? (
                    <Tooltip title={t("editor:imageCanBeChanged")}>
                        <FormControlLabel
                            control={
                                <Switch
                                    size="small"
                                    checked={isImageEditable}
                                    name="isImageEditable"
                                    onClick={handleChangeEditable}
                                />
                            }
                            label={<Typography variant="body2">{t("editor:editable")}</Typography>}
                        />
                    </Tooltip>
                ) : (
                    <></>
                )
            }
            component={
                <Box width="100%" pb={0.5}>
                    <PropertyRow>
                        <Box display="flex" alignItems="center" gap={1}>
                            {!isImageSequence && <LoadImageButton object={object} />}
                            <DataSourceIndicator content={getObjectDataSourceContent(object)} />
                        </Box>
                    </PropertyRow>
                </Box>
            }
        />
    )
}

export default ImageProperties
